export default __webpack_public_path__ + "static/media/mid-b-12-med.8e969ee5.jpg";